import React from 'react';

/**
 * BreadcrumbBar — universal breadcrumb + back button.
 *
 * Props:
 *   items      — ['Master', 'Dependencies', 'Impact-Analyse']
 *   onBack     — () => void (back button handler)
 *   showBack   — boolean, default true
 *   accent     — CSS color for current item
 *   steps      — total steps (wizard mode)
 *   currentStep — current step number (wizard mode)
 */
export default function BreadcrumbBar({ items = [], onBack, showBack = true, accent = 'var(--accent)', steps, currentStep }) {
  if (items.length === 0 && !steps) return null;

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      padding: '6px var(--gap-md, 16px)',
      borderBottom: '1px solid var(--border, rgba(255,255,255,0.08))',
      fontSize: 12,
      flexShrink: 0,
      minHeight: 32,
    }}>
      {showBack && onBack && (
        <button
          onClick={onBack}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            padding: '2px 8px',
            borderRadius: 4,
            border: '1px solid var(--border, rgba(255,255,255,0.08))',
            background: 'transparent',
            color: 'var(--text-muted, #565f89)',
            cursor: 'pointer',
            fontSize: 11,
            fontFamily: 'inherit',
            marginRight: 8,
            transition: 'color 150ms ease',
          }}
          onMouseEnter={e => { e.currentTarget.style.color = 'var(--text-primary, #c0caf5)'; }}
          onMouseLeave={e => { e.currentTarget.style.color = 'var(--text-muted, #565f89)'; }}
        >
          &#8592; Zurueck
        </button>
      )}

      {/* Breadcrumb items */}
      {items.map((item, i) => (
        <span key={i} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          {i > 0 && <span style={{ color: 'var(--text-muted, #565f89)', opacity: 0.5 }}>/</span>}
          <span style={{
            color: i === items.length - 1 ? accent : 'var(--text-muted, #565f89)',
            fontWeight: i === items.length - 1 ? 600 : 400,
          }}>
            {item}
          </span>
        </span>
      ))}

      {/* Wizard mode: Step X/Y */}
      {steps && currentStep && (
        <span style={{
          marginLeft: 'auto',
          color: 'var(--text-muted, #565f89)',
          fontFamily: 'var(--font-mono, monospace)',
          fontSize: 11,
        }}>
          Schritt {currentStep}/{steps}
        </span>
      )}
    </div>
  );
}
